import React, { FC, memo } from 'react'
import { AnyStyledComponent } from 'styled-components'
import { useCurrentSlideIndex } from '../../../hooks/carousel'
import { ControlsContainer, PrevButton, NextButton, ButtonIcon, CarouselControlButton } from './styles'
import { ChevronLeftIcon, ChevronRightIcon } from '../icons'
import { getSafeDisableProps } from '../../../utils/dom-utils'

interface PrevNextControlsProps {
    totalObjects: number
    visibleSlides: number
    desktopTop?: string
    desktopRight?: string
    wideTop?: string
    wideRight?: string
}

const PrevNextControls: FC<PrevNextControlsProps> = ({
    totalObjects,
    visibleSlides,
    desktopTop = '-3.25rem',
    desktopRight = '0.5rem',
    wideTop = '-3.5rem',
    wideRight = '0.5rem',
}) => {
    const currentSlideIndex = useCurrentSlideIndex()
    const isFirstSlide = currentSlideIndex === 0
    const isLastSlide = currentSlideIndex >= totalObjects - visibleSlides

    const prevButtonDisableAttrs = getSafeDisableProps(isFirstSlide)
    const nextButtonDisableAttrs = getSafeDisableProps(isLastSlide)

    return (
        <ControlsContainer
            $desktopTop={desktopTop}
            $desktopRight={desktopRight}
            $wideTop={wideTop}
            $wideRight={wideRight}
        >
            {/*
              Render a plain disabled button on first slide to avoid SSR/hydration race condition.
              ButtonBack relies on CarouselContext which may not be ready on first render,
              causing a brief window where the button appears interactive.
            */}
            {isFirstSlide ? (
                <CarouselControlButton disabled>
                    <ButtonIcon as={ChevronLeftIcon as AnyStyledComponent} />
                </CarouselControlButton>
            ) : (
                <PrevButton {...prevButtonDisableAttrs}>
                    <ButtonIcon as={ChevronLeftIcon as AnyStyledComponent} />
                </PrevButton>
            )}
            <NextButton {...nextButtonDisableAttrs}>
                <ButtonIcon as={ChevronRightIcon as AnyStyledComponent} />
            </NextButton>
        </ControlsContainer>
    )
}

export default memo(PrevNextControls)
